import { render, staticRenderFns } from "./driverList.vue?vue&type=template&id=2f2bd4a4&"
import script from "./driverList.vue?vue&type=script&lang=js&"
export * from "./driverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports